var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-rounded-button"},[_c('button',{staticClass:"chat-rounded-button__button",class:( _obj = {}, _obj['chat-rounded-button__button_disabled'] = _vm.disabled, _obj ),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }